var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49925 7.5078C9.3237 7.5078 10.8027 6.05098 10.8027 4.2539C10.8027 2.45682 9.3237 1 7.49925 1C5.67481 1 4.1958 2.45682 4.1958 4.2539C4.1958 6.05098 5.67481 7.5078 7.49925 7.5078Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11951 14.0155C1.4305 14.0155 0.887794 13.402 1.01993 12.7372C1.62399 9.75759 4.29507 7.50775 7.49941 7.50775C10.7038 7.50775 13.3748 9.75294 13.9789 12.7372C14.1158 13.402 13.5683 14.0155 12.8793 14.0155H2.11951Z",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.d26cc83a51399f7ec35fb67345a0423e.svg";
export { ForwardRef as ReactComponent };